import React from 'react'
import { Routes, Route } from 'react-router-dom'
import TesislerHomePage from './pages/TesislerHomePage/TesislerHomePage'
import TesislerList from './pages/TesislerList'
import HobiBahcesiGirisSistemi from './pages/HobiBahcesiGirisSistemi'
import NotificationPage from './pages/HobiBahcesiGirisSistemi/NotificationPage'
import NotificationDetail from './pages/HobiBahcesiGirisSistemi/NotificationPage/NotificationDetail'
import GuestProcessPage from './pages/HobiBahcesiGirisSistemi/GuestProcessPage'
import GuestAddFormPage from './pages/HobiBahcesiGirisSistemi/GuestAddFormPage'
import HistoryPage from './pages/HobiBahcesiGirisSistemi/HistoryPage'

import './App.css'

const App = () => {
  return (
    <>
      <Routes>
        <Route path='/' index element={<TesislerList />} />
        <Route path='/home' element={<TesislerHomePage />} />
        <Route path='/hobiHome' element={<HobiBahcesiGirisSistemi />} />
        <Route path='/hobiNotification' element={<NotificationPage />} />
        <Route
          path='/hobiNotificationDetail'
          element={<NotificationDetail />}
        />
        <Route path='/hobiGuestProcess' element={<GuestProcessPage />} />
        <Route path='/hobiGuestAdd' element={<GuestAddFormPage />} />
        <Route path='/hobiHistoryPage' element={<HistoryPage />} />
      </Routes>
    </>
  )
}

export default App
